


















import Vue from 'vue';

export default Vue.extend({
  name: 'MStoreUnsupportedInput',
  props: {
    fieldLabel: {
      type: String,
      required: true
    },
    htmlElementId: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: null
    }
  }
});
